"use client";

import FeatureHighlightSection from "@/components/FeatureHighlightSection/FeatureHighlightSection";

const WhyBusinessesChooseSection = ({ whyBusinessesChoose }) => {
  if (!whyBusinessesChoose) return null;

  const { title, description, features = [] } = whyBusinessesChoose;

  return (
    <FeatureHighlightSection
      title={title}
      description={description}
      features={features}
      className="why-businesses-choose"
    />
  );
};

export default WhyBusinessesChooseSection;